import { useAuth } from '../aws/AuthContext';

export const usePermission = () => {
  const { permisos = [], session } = useAuth();

  /**
   * Verifica si el usuario tiene permiso para una acción.
   * @param {string} clavePermiso - Ejemplo: 'ruta:ver' o 'pedidos:ver'
   */
  const hasPermission = (clavePermiso) => {
    if (!clavePermiso) return false;

    // 1. Evaluación directa en los permisos asignados a la sesión
    if (Array.isArray(permisos) && permisos.includes(clavePermiso)) {
      return true;
    }

    // 2. Evaluación de Permiso Maestro ('gestionar')
    const [modulo] = clavePermiso.split(':');
    const permisoMaestro = `${modulo}:gestionar`;
    if (Array.isArray(permisos) && permisos.includes(permisoMaestro)) {
      return true;
    }

    // 3. Jerarquía para CEO:
    // Acceso a todo el sistema EXCEPTO para los módulos opcionales ('ruta:ver' y 'pedidos:ver'),
    // los cuales deben estar explícitamente activos en la lista de sus permisos.
    if (session?.rol?.esCEO || session?.rol?.nombre === 'CEO') {
      if (clavePermiso === 'ruta:ver' || clavePermiso === 'pedidos:ver' || clavePermiso === 'clientes:ver_todos') {
        return Array.isArray(permisos) && permisos.includes(clavePermiso);
      }
      return true;
    }

    return false;
  };

  return { hasPermission, permisos };
};